import * as React from 'react';
import { Row } from 'react-bootstrap';

export default (props: { children?: React.ReactNode }) => (    
    <React.Fragment>        
    </React.Fragment>
);
